"use client"

import React from "react"
import { TypeAnimation } from "react-type-animation"
import { MagicTextAnimate } from "./magic-text/MagicTextAnimate"
import Image from 'next/image'
import { useTranslations } from "@/components/I18nProvider"

export function ChatLoader() {
  const t = useTranslations('chat')

  return (
    <div className="flex flex-col items-center justify-center space-y-6">
      <div className="flex items-center justify-center gap-4">
        <Image
          src="/sarki-ai-logo-dark.svg"
          alt="SarkiAI Logo"
          width={96}
          height={96}
          className="h-24 w-26 sm:h-24 sm:w-26 opacity-90"
          priority
        />

        {/* <div className="mt-[-6px] text-left">
          <MagicTextAnimate className="text-2xl sm:text-4xl font-bold">
            <TypeAnimation
              speed={90}
              cursor={true}
              wrapper="span"
              repeat={Infinity}
              sequence={[
                () => { },
                t('welcome_fr'), 2500,
                t('welcome_en'), 2500,
                t('welcome_fl'), 2500,
              ]}
            />
          </MagicTextAnimate>
          <p className="text-xs sm:text-sm text-muted-foreground">
            {t('emptyState.subtitle')}
          </p>
        </div> */}
      </div>
    </div>
  )
}
